<div class="relative flex h-full flex-col gap-3">
  <p class="text-base font-light text-grey">
    {{ 'portal.trainings.setup.enrollment.description' | transloco }}
  </p>
  @if (filteredStudents) {
    <div class="flex grow flex-col gap-6">
      <app-learning-plan-enrollment-table
        [students]="filteredStudents"
        [selectedStudents]="selectedStudents"
        [searchTerm]="searchTerm"
        (searchTermChanged)="onSearchTermChanged($event)"
        (primaryButtonClickEvent)="openUserCreationDialog()"
      ></app-learning-plan-enrollment-table>
      <div class="flex flex-col rounded-xl bg-grey-veryLightGrey p-5">
        <span class="text-lg font-semibold text-blue-dark">{{
          'portal.trainings.setup.enrollment.invitationAndReminder' | transloco
        }}</span>
        <span class="mt-2 text-sm font-light">{{
          'portal.trainings.setup.enrollment.invitationAndReminderDescription'
            | transloco
        }}</span>
      </div>
    </div>
    <app-license-info-card
      [type]="selectedStudents.length ? 'enrollment' : 'basic'"
      [enrollmentDescription]="getEnrollmentDescription()"
      [showLicenseRatioCard]="canEnroll"
      (addLicensesButtonClickEvent)="addLicensesButtonClickEvent.emit()"
      [pendingLicenseAssignments]="pendingLicenseAssignments"
    ></app-license-info-card>
  } @else {
    <div
      class="absolute left-1/2 top-1/2 size-8 -translate-x-1/2 -translate-y-1/2"
    >
      <app-loading />
    </div>
  }
</div>

<!-- User Creation Dialog Template -->
<ng-template #userCreationDialogTemplate>
  <div class="flex flex-col">
    @switch (dialogStep) {
      @case (userCreationDialogSteps.CREATE) {
        <app-user-creation-container
          class="h-full"
          (userSuccessfullyCreatedEvent)="handleUserSuccessfullyCreatedEvent()"
          (backButtonClickEvent)="closeDialog()"
          (csvUploadButtonClickEvent)="showCsvUploadContent()"
        />
      }
      @case (userCreationDialogSteps.CSV) {
        <app-user-csv-upload-container
          class="h-full"
          (backButtonClickEvent)="showUserCreationContent()"
          (usersSuccessfullyCreatedEvent)="handleUserSuccessfullyCreatedEvent()"
        ></app-user-csv-upload-container>
      }
    }
  </div>
</ng-template>
